import { render, staticRenderFns } from "./directory-item.vue?vue&type=template&id=1ed44d6b&"
import script from "./directory-item.vue?vue&type=script&lang=js&"
export * from "./directory-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports